"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function BikeQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util) {
	var self = this;

	var selectedQuote= quoteOptions.getSelectedQuoteResult() ;
	var selectedQuoteForPayment = quoteOptions.getSelectedQuoteResultForPayment() ;
	/**
	 * Retrieves values from UserInputRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from UserInputRepository to return
	 * @private
	 */
	this._getUserInputValueFor = function (dotSeperatedFieldPath) {
		var userInput = userInputRepository.get();
		return Util.findHierarchyStringInObject(userInput, dotSeperatedFieldPath, '.');
	}

	/**
	 * Retrieves values from ServiceResponseRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from ServiceResponseRepository to return
	 * @private
	 */
	this._getServiceResponseValueFor = function (serviceName, dotSeperatedFieldPath) {
		return serviceResponseRepository.getLastResponseFrom(serviceName);
	}

	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._ridersHave_threeYears_restrictedSuspendedDisqualifiedCancelled = function () {
		if (this.riders) {
			var ridersLength = this.riders.length,
				atLeastOneRiderHas = false,
				rider;

			for (var i = 0; i < ridersLength; i++) {
				rider = this.riders[i];

				if (rider.threeYears_restrictedSuspendedDisqualifiedCancelled) {
					atLeastOneRiderHas = true;
					break;
				}
			}

			return atLeastOneRiderHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._ridersHave_threeYears_accidentsClaims = function () {
		if (this.riders) {
			var ridersLength = this.riders.length,
				atLeastOneRiderHas = false,
				rider;

			for (var i = 0; i < ridersLength; i++) {
				rider = this.riders[i];

				if (rider.threeYears_accidentsClaims) {
					atLeastOneRiderHas = true;
					break;
				}
			}

			return atLeastOneRiderHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._ridersHave_fiveYears_chargedOrConvicted = function () {
		if (this.riders) {

			var ridersLength = this.riders.length,
				atLeastOneRiderHas = false,
				rider;

			for (var i = 0; i < ridersLength; i++) {
				rider = this.riders[i];

				if (rider.fiveYears_chargedOrConvicted) {
					atLeastOneRiderHas = true;
					break;
				}
			}

			return atLeastOneRiderHas;
		}
	}

	this.email = this._getUserInputValueFor('bikeForm.tellUsABitMore.yourEmailAddress')?this._getUserInputValueFor('bikeForm.tellUsABitMore.yourEmailAddress'):this._getUserInputValueFor('email');

	this.bikeForm = this._getUserInputValueFor('bikeForm');

	// rego details
	this.regoDetails = this._getServiceResponseValueFor('regoSearch');

	if ( !!this.regoDetails && !!this.bikeForm && !!this.bikeForm.tellUsYourRegoNumber && !!this.bikeForm.tellUsYourRegoNumber.regoNumber) {
		this.regoDetails.regoNumber = this.bikeForm.tellUsYourRegoNumber.regoNumber;
	}

	if ( !! this.regoDetails &&  this.regoDetails.goodRetailPrice ) {
		this.bikeRetailValue = parseInt( this.regoDetails.goodRetailPrice ) ;
	}

	// cover type
	this.selectedQuote = selectedQuote ;
	this.selectedQuoteForPayment = selectedQuoteForPayment;
	//  this._getServiceResponseValueFor('quickQuote');
	if (selectedQuote ) {
		this.annualCoverType = selectedQuote.getAnnual();
		this.monthlyCoverType = selectedQuote.getMonthly();

		this.quoteResult = this.selectedQuoteForPayment ; // selectedQuote.getQuoteResult();
		if ( this.quoteResult ) {
			this.coverageOptions = this.quoteResult.coverageOptions ;
			if ( this.coverageOptions ) {
				this.coverageOptionsToShow = this.coverageOptions.filter(function(op) {
					return op.required === false ;
				});
				this.hasCoverageOptions = this.coverageOptionsToShow.length > 0 ;
			}
			this.excess = this.quoteResult.excess ;
			this.namedRiderExcess = findNamedRiderExcess() ;
		}

		this.motorcycleValue = this.quoteResult.motorcycleValue;
		this.sumInsuredAmount = this.quoteResult.sumInsuredAmount;
		// console.log( ' sum insured ammount is ' , this.sumInsuredAmount ) ;
	}

	/** excess list to be displayed in the quote panel */
	this.displayableExcessList = null;

	this.getDisplayableExcess=function(isCoverSummary) {
		if ( ! this.excess )
			return [] ;

		if ( ! this.displayableExcessList) {
			var filterOut =  ['voluntaryVehicleExcessOptions', 'voluntaryVehicleExcess', 'standardVehicleExcess'] ;
			this.displayableExcessList = [] ;

			for ( var key in this.excess) {
				if ( filterOut.indexOf(key) === -1){
					//dd-6058 - do not display Flexi excess if value is not greater than zero					
					if((key == "flexiExcessExcess" || key == "flexiExcessOptions") && this.excess.flexiExcessExcess <= 0) continue;
					if (key == "flexiExcessExcess") { continue; }
					if (key == "standardExcess") {
						if (isCoverSummary) {
						    var feItemValue = this.excess["flexiExcessExcess"];
							var standardValue = this.excess[key];
							if (!isNaN(feItemValue)) {
								standardValue += feItemValue;
							}
							this.displayableExcessList.push({ key : key, excessValue : standardValue }) ;
						}
						else {
							continue;
						}
					}
					else {
						this.displayableExcessList.push({ key : key, excessValue : this.excess[key] }) ;
					}
										
				}
			}
		}

		return this.displayableExcessList ;
	}

	this.getSelectionExcess=function() {
		if (!this.excess)
			return [] ;
		var options = [-200, -100, 0, 100, 200, 300, 500, 1000, 1500];
		var flexiExcessRange = this.excess.flexiExcessOptions.filter(function(x) {
			return options.indexOf(x) != -1;
		});

		for (var idx = 0; idx < flexiExcessRange.length; idx++) {
			flexiExcessRange[idx] += this.excess.standardExcess;
		}

		return flexiExcessRange;
	}

	function findNamedRiderExcess() {
		var namedRiderExcess = [],
			qr = selectedQuoteForPayment ? selectedQuoteForPayment.response : null ;

		if ( qr && qr.motorcycles) {
			var riders = qr.motorcycles[0].riders ;
			riders.forEach( function(rider) {
				if ( rider.rider
					&& rider.rider.calculatedExcess
					&& rider.rider.calculatedExcess > 0 ) {
					namedRiderExcess.push({
						firstName : rider.rider.person.firstName,
						lastName: rider.rider.person.lastName,
						excessValue : rider.rider.calculatedExcess,
						dob: rider.rider.person.dateOfBirth
					});
				}
			});
		}

		return namedRiderExcess ;
	}

	/**
	* Excluded riders
	*/
	var savedQuoteResult = !!this.quoteResult ? this.quoteResult.response : null;
	if ( savedQuoteResult ) {
		/** excluded rider condition to be correctly diagnosed here */
		// this.excludedRiders = this.quoteResult.excludedRiders ;
		var excludedRiders = [] ;
		savedQuoteResult.motorcycles[0].riders.forEach(function(rider) {
			if ( rider.riderUsage == 'excluded')
				excludedRiders.push(rider.rider.person) ;
		});
		this.excludedRiders = excludedRiders;
	}

	this.hasExcludedRiders = function() {
		return this.excludedRiders && this.excludedRiders.length > 0 ;
	}

	this.riders = [];
	this.postCode = null;
	this.campaignCode = null ;
	if (this.bikeForm) {
		//TODO: set regoNumber based on step 1 or step 4

		// bikeDetails
		if (this.bikeForm.bikeDetails) {
			this.bikeDetails = this.bikeForm.bikeDetails;

			this.bikeDetailsUsage = this.bikeForm.bikeDetails.primaryBikeUse;
			switch (this.bikeDetailsUsage) {
				case 'commercial':
					this.bikeDetailsUsage += ' - ' + this.bikeForm.bikeDetails.commercialActivityType.label;
					break;
				case 'business':
					this.bikeDetailsUsage += ' - ' + this.bikeForm.bikeDetails.businessActivityType.label;
					break;
			}
		}

		if ( this.bikeForm.getStarted ) {
			this.personOrCompany = this.bikeForm.getStarted.personOrCompany;
			this.policyStartDate = this.bikeForm.getStarted.policyStartDate;
		}

		// Main riders & additional riders
		this.additionalRiders = [];

		if (!!this.bikeForm.rider) {
     		var riders=this.bikeForm.rider.riders;
     		if(riders){

				this.mainRider = riders[0];

				if (!!this.bikeForm.mainPolicyHolderContact) {
					this.mainRider.person.phoneNumber = this.bikeForm.mainPolicyHolderContact.primaryPhoneNumber;
				}

      			if(riders.length>1){
         			this.additionalRiders=riders.splice(1,riders.length);
      			}
     		}
		};

		// riders
		if (this.mainRider) {
			this.riders = [this.mainRider];
			this.noClaimBonus = this.mainRider.noClaimBonus ; 
		}
		if (this.additionalRiders) {
			this.riders = this.riders.concat(this.additionalRiders);
		}

		// address
		var aboutYourBike = this.bikeForm.aboutYourBike ;
		if ( aboutYourBike && aboutYourBike.address ) {
			this.address = aboutYourBike.address	;
			this.postCode = this.address.postalCode;
			this.state = this.address.state ;
		}

		if ( this.bikeForm.promotionalCode ) {
			this.campaignCode = this.bikeForm.promotionalCode.promotionalCode ;
		}

	}

	// this.quoteId = this._getServiceResponseValueFor('service-name', 'quote.quoteId');
	this.quoteId = null ;
	if ( quoteRequestRepository.getSelectedQuoteCredentials() )
		this.quoteId = quoteRequestRepository.getSelectedQuoteCredentials().quoteID ;


	/** Google Tag Manager data **/
	this.gtmPolicyHolder = this.mainRider ? this.mainRider.person : null;
	this.gtmTransactionAffiliation = 'QBE Direct' ;
	this.insuranceType =  MODULE_INFO.insuranceType ;
	this.productCode = MODULE_INFO.productCode ;


}
